import React from "react";
import PageLayout from "../../public/pages/PageLayout";

export default function RolePageLayout({ requiredRoleSlug, logoutPath = "/user-login" }) {
  return (
    <PageLayout
      requiredRoleSlug={requiredRoleSlug}
      logoutPath={logoutPath}
    />
  );
}
